module.exports = __webpack_public_path__ + "img/40_84.e91f57dd.png";